export function currentLocation(suffix=null) {
  let searchFormEl = document.querySelector('.search')

  let activePageEl = document.querySelector('.page-item.active')
  let page_number = (activePageEl) ? activePageEl.querySelector('.page-link').innerHTML : '1'

  if (searchFormEl) {
    let action = searchFormEl.getAttribute('action').replace('.js', '')
    if (suffix) { action = `${action}.${suffix}` }
    let params = $(searchFormEl).serialize()


    if (params) {
      params = `${params}&page=${page_number}`
      return `${location.origin}${action}?${params}`
    } else {
      return `${location.origin}${action}?page=${page_number}`
    }

  } else {
    return location
  }
}
